export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 bg-accent-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">视频爆料</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20footage%20style%2C%20warm%20cinematic%20lighting%20with%20red%20and%20amber%20tones%2C%20paparazzi%20style%20night%20photography%2C%20mysterious%20atmosphere%2C%20blurred%20urban%20background%20with%20bokeh%20lights%2C%20investigative%20journalism%20aesthetic&width=800&height=450&seq=media-card-01&orientation=landscape"
                alt="独家实拍：顶流男星深夜出入高档小区"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-2 right-2 bg-foreground-900/80 text-background-50 text-[10px] px-2 py-1 rounded whitespace-nowrap">3小时前</div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">独家实拍：顶流男星深夜出入高档小区</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">记者蹲守72小时拍到的独家画面，全程高清记录</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-eye-line"></i><span>128万 次浏览</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20night%20scene%20with%20warm%20amber%20glow%2C%20silhouette%20of%20film%20director%20chair%20on%20dark%20set%2C%20dramatic%20spotlight%20illumination%2C%20mysterious%20backstage%20atmosphere%2C%20investigative%20documentary%20style%2C%20rich%20texture%20and%20contrast&width=800&height=450&seq=media-card-02&orientation=landscape"
                alt="录音曝光：某导演选角现场对话流出"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-2 right-2 bg-foreground-900/80 text-background-50 text-[10px] px-2 py-1 rounded whitespace-nowrap">6小时前</div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">录音曝光：某导演选角现场对话流出</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">内部人员匿名提供的录音材料，揭开选角黑幕</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-eye-line"></i><span>96万 次浏览</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20dramatic%20chat%20messages%20with%20warm%20red%20glow%2C%20dark%20moody%20bedroom%20setting%2C%20emotional%20breakup%20theme%2C%20soft%20amber%20accent%20light%2C%20cinematic%20composition%2C%20intimate%20atmosphere%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=media-card-03&orientation=landscape"
                alt="聊天截图：网红情侣分手前的最后对话"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-2 right-2 bg-foreground-900/80 text-background-50 text-[10px] px-2 py-1 rounded whitespace-nowrap">12小时前</div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">聊天截图：网红情侣分手前的最后对话</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">当事人闺蜜独家提供的微信聊天记录完整版</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-eye-line"></i><span>205万 次浏览</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}